








































































































































































import { Component, Prop, Emit } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { defaultSystemCode, SystemCode } from '@/api'
import { OrderIdMaxDigits } from '@/types'
import { dataStore } from '@/utils/store-accessor'

export interface CollectionDetailTabBasicItem {
  collectionNo: string
  collectionType: SystemCode
  opacShow: boolean
  orderId: number
  processedDate: string
  status: SystemCode
  handlingType: SystemCode
  removeExpectedDate: string
  orderStatus: SystemCode
  processedTime: string
  storeType: SystemCode
  removeTime: string
  cancelReason: SystemCode
  processedBranchCode: SystemCode
  parentCollectionNo: string
  parentDisplayTitle: string
  parentComposedCollectionNo: string
  setNumber: number
  appendixCode: SystemCode
  removeReason: SystemCode
  managementFlag: SystemCode
  processedPlaceCode: SystemCode
}

export const defaultCollectionDetailTabBasicItem = (): CollectionDetailTabBasicItem => ({
  collectionNo: '',
  collectionType: defaultSystemCode(),
  opacShow: false,
  orderId: 0,
  processedDate: '',
  status: defaultSystemCode(),
  handlingType: defaultSystemCode(),
  removeExpectedDate: '',
  orderStatus: defaultSystemCode(),
  processedTime: '',
  storeType: defaultSystemCode(),
  removeTime: '', // 日付
  cancelReason: defaultSystemCode(),
  processedBranchCode: defaultSystemCode(),
  parentCollectionNo: '',
  parentDisplayTitle: '',
  parentComposedCollectionNo: '',
  setNumber: 0,
  appendixCode: defaultSystemCode(),
  removeReason: defaultSystemCode(),
  managementFlag: defaultSystemCode(),
  processedPlaceCode: defaultSystemCode()
})

@Component({
  components: {}
})
export default class CollectionDetailTabBasic extends ComponentVue {
  @Prop({
    type: Object,
    required: true
  })
  item!: CollectionDetailTabBasicItem

  @Prop({
    type: Boolean,
    default: false
  })
  isOrder!: boolean

  get orderId(): string {
    if (this.item.orderId !== 0) {
      return String(this.item.orderId).padStart(OrderIdMaxDigits, '0')
    }

    return ''
  }

  get isCollection(): boolean {
    return !this.isOrder
  }

  get opacShow(): string {
    if (this.isCollection) {
      return this.item.opacShow ? '表示する' : '表示しない'
    }

    return ''
  }

  get displaySetNumber(): boolean {
    return dataStore.displayBibliographyDetailPageSetNumber
  }

  @Emit('click:parent-collection-no-link')
  onClickParentCollectionNoLink(): void {}
}
